import TableAntd from "components/elements/Table";
import dayjs from "dayjs";

const { Modal, Space, Row, Button, Col, Flex } = require("antd");
const { useTranslation } = require("react-i18next");

function LeaveRightsDetailReportModal({
    isModalDetailOpen,
    setIsModalDetailOpen,
    reportTableLeaveRights = [],
    selectedRecord
}) {
    const { t, i18n } = useTranslation();

    const formatDate = (date) => {
        if (!date) return "-";
        const formattedDate = dayjs(date);
        if (i18n.language === "th") {
            return formattedDate.locale('th').add(543, 'year').format('DD/MM/YYYY');
        }
        return formattedDate.format('DD/MM/YYYY');
    };

    const columns = [
        {
            title: <div className="text-table">{t('report.leave_type')}</div>,
            dataIndex: "leaveType",
            key: "leaveType",
            align: "left",
            width: 400,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return record?.leaveTypeNameEn;
                }
                return record?.leaveTypeName;
            },
        },
        {
            title: <div className="text-table">{t('report.Rights_received')}</div>,
            dataIndex: "rightRecieve",
            key: "rightRecieve",
            align: "center",
            width: 200,
            render: (_, record) => {
                if (record?.unlimited === "Y") {
                    return t("unlimited");
                } else {
                    if (record?.totalLeaveDays && record?.totalLeaveHour) {
                        return `${record.totalLeaveDays} ${t("unit.day")} ${record.totalLeaveHour} ${t("unit.hours")}`;
                    } else if (record?.totalLeaveDays) {
                        return `${record.totalLeaveDays} ${t("unit.day")}`;
                    } else if (record?.totalLeaveHour) {
                        return `${record.totalLeaveHour} ${t("unit.hours")}`;
                    } else {
                        return "-";
                    }
                }
            }
        },
        {
            title: <div className="text-table">{t('report.Rights_used')}</div>,
            dataIndex: "rightUsed",
            key: "rightUsed",
            align: "center",
            width: 200,
            render: (_, record) => {
                if (record?.usedLeaveDays && record?.usedLeaveHour) {
                    return record?.usedLeaveDays + " " + t("unit.day") + " " + record?.usedLeaveHour + " " + t("unit.hours")
                };
                if (record?.usedLeaveDays) {
                    return record?.usedLeaveDays + " " + t("unit.day")
                }
                if (record?.usedLeaveHour) {
                    return record?.usedLeaveHour + " " + t("unit.hours")
                }
                return "-";
            }
        },
        {
            title: <div className="text-table">{t('report.Accumulate_rights')}</div>,
            dataIndex: "accumulatedRights",
            key: "accumulatedRights",
            align: "center",
            width: 200,
            render: (_, record) => {
                return "0" // default 0 ไว้ก่อน เหมือนยังไม่มี logic หลังบ้าน
            }
        },
        {
            title: <div className="text-table">{t('report.accumulated_rights_used')}</div>,
            dataIndex: "accumulatedRightsUsed",
            key: "accumulatedRightsUsed",
            align: "center",
            width: 200,
            render: (_, record) => {
                return "0" // default 0 ไว้ก่อน เหมือนยังไม่มี logic หลังบ้าน
            }
        },
        {
            title: <div className="text-table">{t('report.remaining')}</div>,
            dataIndex: "remainingRights",
            key: "remainingRights",
            align: "center",
            width: 200,
            render: (_, record) => {
                if (record?.unlimited === "Y") {
                    return t("unlimited");
                } else {
                    if (record?.remainingLeaveDays && record?.remainingLeaveHour) {
                        return `${record.remainingLeaveDays} ${t("unit.day")} ${record.remainingLeaveHour} ${t("unit.hours")}`;
                    } else if (record?.remainingLeaveDays) {
                        return `${record.remainingLeaveDays} ${t("unit.day")}`;
                    } else if (record?.remainingLeaveHour) {
                        return `${record.remainingLeaveHour} ${t("unit.hours")}`;
                    } else {
                        return "-";
                    }
                }
            }
        },
    ]
    return (
        <Modal
            title={<span color="#42526D">{t("report.leave_rights_rport_detail")}</span>}
            open={isModalDetailOpen}
            destroyOnClose
            footer={null}
            closable={false}
            maskClosable={false}
            width={i18n.language === "en" ? 900 : 760}
        >
            {selectedRecord && (
                <Space direction="vertical" size={24} style={{ width: "100%" }}>
                    <Flex gap={16}>
                        <Col span={12}>
                            <Flex gap={8}>
                                <Col span={10}>
                                    <span style={{ color: "#42526D" }}>{t("employee.label.employee-name")}</span>
                                </Col>
                                <Col span={14}>
                                    <span style={{ color: "#42526D", fontWeight: "bold" }}>
                                        {i18n.language === "en" ? selectedRecord?.nameEn + " " + selectedRecord?.surNameEn : selectedRecord?.name + " " + selectedRecord?.surName}
                                    </span>
                                </Col>
                            </Flex>

                            <Flex gap={8}>
                                <Col span={10}>
                                    <span style={{ color: "#42526D" }}>{t("employee.label.employee_no")}</span>
                                </Col>
                                <Col span={14}>
                                    <span style={{ color: "#42526D", fontWeight: "bold" }}>{selectedRecord?.employeeNo ? selectedRecord?.employeeNo : "-"}</span>
                                </Col>
                            </Flex>

                            <Flex gap={8}>
                                <Col span={10}>
                                    <span style={{ color: "#42526D" }}>{t("employment-information.label.supervisor")}</span>
                                </Col>
                                <Col span={14}>
                                    <span style={{ color: "#42526D", fontWeight: "bold" }}>{selectedRecord?.supervisor?.[0]?.name
                                        ? i18n.language === "en"
                                            ? selectedRecord?.supervisor?.[0]?.nameEn + " " + selectedRecord?.supervisor?.[0]?.surNameEn
                                            : selectedRecord?.supervisor?.[0]?.name + " " + selectedRecord?.supervisor?.[0]?.surName
                                        : "-"}</span>
                                </Col>
                            </Flex>
                        </Col>
                        <Col span={12}>
                            <Flex gap={8}>
                                <Col span={10}>
                                    <span style={{ color: "#42526D" }}>{t("work-start-date")}</span>
                                </Col>
                                <Col span={14}>
                                    <span style={{ color: "#42526D", fontWeight: "bold" }}>{formatDate(selectedRecord?.employmentDate)}</span>
                                </Col>
                            </Flex>

                            <Flex gap={8}>
                                <Col span={10}>
                                    <span style={{ color: "#42526D" }}>{t("employee.label.probation_date")}</span>
                                </Col>
                                <Col span={14}>
                                    <span style={{ color: "#42526D", fontWeight: "bold" }}>{formatDate(selectedRecord?.probationDate)}</span>
                                </Col>
                            </Flex>

                            <Flex gap={8}>
                                <Col span={10}>
                                    <span style={{ color: "#42526D" }}>{t("employee.label.position")}</span>
                                </Col>
                                <Col span={14}>
                                    <span style={{ color: "#42526D", fontWeight: "bold" }}>{i18n.language === "en" ? selectedRecord?.position?.positionNameEn : selectedRecord?.position?.positionName}</span>
                                </Col>
                            </Flex>
                        </Col>
                    </Flex>

                    <TableAntd
                        columns={columns}
                        rowKey={(record) => record.id}
                        dataSource={selectedRecord?.txnRemainingLeave}
                    />

                    <Row justify={"end"}>
                        <Button style={{ borderRadius: "8px", height: "40px" }} type="default" onClick={() => { setIsModalDetailOpen(false) }}>
                            <span style={{ fontWeight: "bold", color: "#344054" }}>{t("common.cancel").toUpperCase()}</span>
                        </Button>
                    </Row>
                </Space>
            )}
        </Modal>
    )
}

export default LeaveRightsDetailReportModal;